import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import './globalcomponents' // 全局组件注册

Vue.config.productionTip = false
Vue.use(ElementUI)


new Vue({
  store,
  router,
  el:'#app',
  render: h => h(App),
}).$mount('#app')
